import { render, staticRenderFns } from "./Invitaciones.vue?vue&type=template&id=44239226&scoped=true"
import script from "./Invitaciones.vue?vue&type=script&lang=js"
export * from "./Invitaciones.vue?vue&type=script&lang=js"
import style0 from "./Invitaciones.vue?vue&type=style&index=0&id=44239226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44239226",
  null
  
)

export default component.exports